import { render, staticRenderFns } from "./sysConfig.vue?vue&type=template&id=6680685f&"
import script from "./sysConfig.vue?vue&type=script&lang=js&"
export * from "./sysConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports